import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as actions from "../../actions/acBookingFlow"
import { BookingFlowStep as Step } from "../../actions/acBookingFlow"

import pinAgenda from '../../static/img/pin-agenda.png'
import { BookingFlowStep, InfoButton, PootsyButton } from "../DesignFunctions"
import PootsySelectInput from "../shared/PootsySelectInput"
import TimeSlotSeeker from "./TimeSlotSeeker"
import { WomanAvatar, ManAvatar } from '../../static/svg/worker-avatars'
import verifiedIcon from '../../static/img/ic-verified.png'
import selectedIcon from '../../static/img/selected_icon.png'
import WorkerContainer from "./WorkerContainer"
import ZipCodeNotCoveredModal from "./ZipCodeNotCoveredModal";

class BookingFlowDateSelection extends Component {

	constructor(props) {
		super(props)

		this.state = {
			showWorkerSelection: false
		}
	}

	render() {
		let { t } = this.context

		let headerContent = {
			picto: pinAgenda,
			title: t('booking_flow_third_step_header')
		}

		return (
			<BookingFlowStep customClass="step-three" headerContent={headerContent}>
				{this.props.bookingFlow.enterZipCodeNotCovered && <ZipCodeNotCoveredModal title={t('tss_empty_modal_title')} description={t('tss_empty_modal_description')} />}
				<div className="duration-frequency-container">
					<div className="line">
						{t('booking_flow_date_selection_title_first_part')} {this.renderDurationSelect()} {t('booking_flow_date_selection_title_second_part')} {this.renderFrequencySelect()}
					</div>
					<div className="line">{t('booking_flow_date_selection_subtitle', { voucher_count: this.props.duration })}</div>
				</div>

				<TimeSlotSeeker/>
				{this.renderWorkerSection()}

				<div className="divider"/>

				<div className="bottom">
					<div className="previous-step" onClick={this.goToPreviousStep}>← {t('previous')}</div>
					<PootsyButton
						disabled={this.props.selectedTimeSlot === undefined}
						text={t('next_step')}
						onClick={this.onNextButtonClick}/>
				</div>
			</BookingFlowStep>
		)
	}

	renderDurationSelect = () => {
		let { t } = this.context

		let options = []
		for (let i = 3; i <= 10; i++) {
			options.push({
				value: i,
				label: i + ' ' + t('common_hours')
			})
		}

		return (
			<PootsySelectInput options={options}
							   selectedValue={this.props.duration}
							   onChange={this.onDurationChanged}/>
		)
	}

	renderFrequencySelect = () => {
		let { t } = this.context

		let options = [
			{
				value: 0,
				label: t('booking_flow_frequency_once')
			},
			{
				value: 1,
				label: t('booking_flow_frequency_every_week')
			},
			{
				value: 2,
				label: t('booking_flow_frequency_every_two_weeks')
			}
		]

		return (
			<PootsySelectInput options={options}
							   selectedValue={this.props.frequency}
							   onChange={this.onFrequencyChanged}/>
		)
	}

	renderWorkerSection = () => {
		if (this.props.selectedTimeSlot) {
			if (this.state.showWorkerSelection) {
				return this.renderWorkerSelection(this.props.selectedHourTimeSlots)
			} else {
				return this.renderSelectedWorker(this.props.selectedTimeSlot)
			}
		}

		return null
	}

	renderSelectedWorker = (timeSlot) => {
		let worker = timeSlot.worker

		return (
			<WorkerContainer worker={worker}
							 displayVerifiedIcon={true}
							 onShowOtherWorkersClick={this.props.selectedHourTimeSlots.length ? this.onShowOtherWorkersClick : undefined}/>
		)
	}

	renderWorkerSelection = (timeSlots) => {
		let { t } = this.context

		return (
			<div className="worker-selection">
				<div className="title">{t('booking_flow_date_selection_worker_selection_title')}</div>
				<div className="sub-title">{t('booking_flow_date_selection_worker_selection_sub_title')}</div>
				<div className="workers">
					{timeSlots.map((timeSlot, index) => this.renderWorker(timeSlot, index, (index === 0), timeSlot.key === this.props.selectedTimeSlot.key))}
				</div>
			</div>
		)
	}

	renderWorker = (timeSlot, key, isRecommended, isSelected) => {
		let { t } = this.context

		return (
			<div className="worker-container" key={key} onClick={() => this.onWorkerClick(timeSlot)}>
				{isRecommended && <div className="recommended">{t('booking_flow_date_selection_worker_selection_recommended')}</div>}
				<div className="worker">
					{this.renderWorkerAvatar(timeSlot, false, isSelected)}
					<div className="name">{timeSlot.worker.firstName}</div>
					<div className="affiliate">{timeSlot.worker.affiliateName}</div>
					<div className="labels-container">
						{timeSlot.labels.map((label, index) =>
							<InfoButton key={index} className="info-button" icon={label.badge} text={t(label.descriptionKey)}/>
						)}
					</div>
					<div className="button-container">
						<div
							className={"button" + (isSelected ? " selected" : "")}>{isSelected ? t('booking_flow_date_selection_worker_selection_selected') : t('booking_flow_date_selection_worker_selection_select')}</div>
					</div>
				</div>
			</div>
		)
	}

	renderWorkerAvatar = (timeSlot, displayVerifiedIcon, isSelected = false) => {
		return (
			<div className="worker-avatar">
				{timeSlot.worker.title === 'mr' ? <ManAvatar isSelected={isSelected} /> : <WomanAvatar isSelected={isSelected} />}
				{displayVerifiedIcon && <img className="verified-icon" alt="" src={verifiedIcon}/>}
				{isSelected && <img className="selected-icon" alt="" src={selectedIcon}/>}

			</div>
		)
	}

	onDurationChanged = (option) => {
		this.props.dispatch(actions.bookingFlowDataChange({ timeSlots: [] }))
		this.props.dispatch(actions.updateDuration(option.value))
	}

	onFrequencyChanged = (option) => {
		this.props.dispatch(actions.bookingFlowDataChange({ timeSlots: [], frequency: option.value }))
	}

	onShowOtherWorkersClick = () => {
		this.setState({
			showWorkerSelection: true
		})
	}

	onWorkerClick = (timeSlot) => {
		this.props.dispatch(actions.bookingFlowDataChange({ selectedTimeSlot: timeSlot }))
	}

	goToPreviousStep = () => {
		this.props.dispatch(actions.bookingFlowMetaChange({ currentStep: Step.NEEDS }))
	}

	onNextButtonClick = () => {
		this.props.dispatch(actions.bookingFlowValidateStepAvailabilities())
	}
}

BookingFlowDateSelection.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	duration: state.dataReducer.bookingFlow.duration,
	frequency: state.dataReducer.bookingFlow.frequency,
	selectedHourTimeSlots: state.dataReducer.bookingFlow.selectedHourTimeSlots,
	selectedTimeSlot: state.dataReducer.bookingFlow.selectedTimeSlot,
	bookingFlow: state.metadataReducer.bookingFlow,
})
export default connect(mapStateToProps)(BookingFlowDateSelection);



// WEBPACK FOOTER //
// ./src/components/bookingflow/BookingFlowDateSelection.js